import React, { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import DropDownControl from '../../components/DropDownControl'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import {  useLocation, useNavigate, useParams } from 'react-router-dom'
import { jobopeningmanagement } from "../../Routes/routingConsts";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputControl from '../../components/InputControl'
import Swal from 'sweetalert2'
import ButtonWithLoader from '../../components/ButtonWithLoader/ButtonWithLoader'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import  { CKEditor } from '@ckeditor/ckeditor5-react'
// import DecupuledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import  { components } from 'react-select'
import { Spinner } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import GooglePlacesAutocomplete ,{geocodeByPlaceId } from 'react-google-places-autocomplete';
import DropDownControlForCategery from '../../components/DropDownControlForCategery/DropDownControlForCategery'
import { ReactComponent as LeftArrowIcon } from '../../assets/images/left-arrow-icon.svg'

import "./editor.scss"

const getlocation = (datalist) => {
    return requestApi
        .post(`/user-home/location`, { search: datalist })
        .then((res) => {
            return res.data
        })
}

const fetchQuery = (query) => {
    return requestApi
        .post(`/user-home/job-skill`, {
            search: query
        })
        .then((res) => {
            return res.data
        })
}

export async function addnewSkill(skillname) {
    return await requestApi.post('/employer/new-add-skill', {
        name: skillname
        // temp_skill: true
    })
}

const CreatNewOpening = () => {

    // YUP validation
    const createJobOpeningvalidation = yup.object({
        jobTitle: yup.string().trim().required('Please enter job title'),
        experience: yup.string().trim().required('Please enter your experience'),
        categoryId: yup.mixed().required('Please select category'),
        shiftType: yup.string().required('Please select shift type'),
        location: yup
            .object()
            .nullable(true)
            .required('Please select location.'),
        jobRole: yup.string().trim().required('Please enter job role'),
        jobGrade: yup.string().trim().required('Please enter job grade'),
        salary: yup.string().trim().required('Please enter salary').test('is-number', 'Please enter a valid number', value => {
        return !isNaN(Number(value));
        }),
        salaryType: yup.string().required('Please select salary type'),
        jobType: yup.string().required('Please select job type'),
        summary: yup
            .string()
            .trim()
            .required('Please enter job summary'),
        mainDuty: yup
            .string()
            .trim()
            .required('Please enter job main duty'),
        aboutUs: yup
            .string()
            .trim()
            .required('Please enter about us'),
        description: yup
            .string()
            .trim()
            .required('Please enter job description'),
        lookingFor: yup
            .string()
            .trim()
            .required('Please enter looking for'),
        additionalInfo: yup
            .string()
            .trim()
            .required('Please enter additional info'),
    })


    // Hooks
    const [show, setShow] = useState(false)
    const { jobOpeningId } = useParams()
    const { state } = useLocation()
    const navigate = useNavigate()


const handlePlaceSelect = (place) => {
    geocodeByPlaceId(place.place_id)
      .then((results) => {
        const { lat, lng } = results[0].geometry.location;
        setValue('latitude', lat());
        setValue('longitude', lng());
      })
      .catch((error) => {
        console.error('Error getting location details:', error);
      });
  };

    const {
        control,
        register,
        watch,
        clearErrors,
        handleSubmit,
        reset,
        setError,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(createJobOpeningvalidation),
    })
    const { Option } = components
    const [editorState, setEditorState] = useState()
    const skillField = useRef(null)
    const locationField = useRef(null)
    const industryField = useRef(null)
    const [userSkills, setuserSkills] = useState([])
    const [skill, setSkill] = useState('')
    const [changeDataLocation, setChangeDataLoaction] = useState('')
    const [ckeditordata, setckeditordata] = useState('')
    const handleCancleButton = () => {
        // if (state === 'dashBoardJobOpening') {
        //     navigate('')
        // } else {
        //     navigate('')
        // }
        navigate(jobopeningmanagement)
    }
    const IconOption = (props) => {
        const { label, industryName } = props.data

        return (
            <Option {...props}>
                <div className="react-select-option">{industryName}</div>
            </Option>
        )
    }
    const onEditorStateChange = (e) => {
        setEditorState(e)
    }
    const handleClose = () => {
        setShow(false)
        skillreset()
        skillField.current.value = ''
        setSkill('')
    }
    const addnewmutation = useMutation(addnewSkill, {
        onSuccess: ({ data }) => {
            setValue('keywords', [
                ...userSkills,
                { name: data?.data?.name, _id: data?.data?._id }
            ])
            setuserSkills((prev) => {
                return [
                    ...prev,
                    { name: data?.data?.name, _id: data?.data?._id }
                ]
            })

            handleClose()
            if (userSkills.length === 0) {
                clearErrors('keywords')
            }

            // addmutation.mutate(data?.data?._id)
            // setsearchedVal('')
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    const handleOnSubmit = (data) => {
        addnewmutation.mutate(data?.skill)
    }
    const { data: country, isLoading: countryLoading } = useQuery({
        queryKey: ['country', changeDataLocation],
        queryFn: () => getlocation(changeDataLocation),
        enabled: !!changeDataLocation,
        onSuccess: (data) => {}
    })

    const mySkillValidation = yup.object({
        skill: yup
            .string()
            .trim()
            .max(25, 'Must be at max 25 characters')
            .required('Please enter skill')
    })
    const {
        register: skillregister,
        reset: skillreset,
        setError: skilsetError,
        setValue: skillsetValue,
        clearErrors: skillclearErrors,
        handleSubmit: skillhandleSubmit,
        formState: { errors: skillerrors }
    } = useForm({ resolver: yupResolver(mySkillValidation) })
    
    async function getachivedDetail({ queryKey }) {
        return await requestApi
            .post(
                `/job-opening/view`,
                { jobOpeningId: state },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const {
        data: getAcrchived,
        isLoading: viewOnCopy,
        isFetching
    } = useQuery({
        queryKey: ['Archived'],
        queryFn: getachivedDetail,
        enabled: !!state,
        onSuccess: (data) => {
            reset({
                jobTitle: data.data.jobTitle,
                // industry: data.data.industry,

                industry: {
                    industryId: data?.data?.industry,
                    industryName: data?.data?.industryName
                },
                // location: {
                //     cityId: data?.data?.cityId,
                //     location: data?.data?.location
                // }
                location: {
                    cityId: data?.data?.locationId,
                    location: data?.data?.location
                },
                // location: data.data.location,
                experience:
                    data.data.experience > 1
                        ? `${data.data.experience} Years`
                        : `${data.data.experience} Year`,
                jobType: data.data.jobType,
                // salary: data.data.salary,
                totalOpening: data.data.totalOpening,
                jobStatus: data.data.jobStatus,
                locationType: data.data.locationType,
                keySkill: data.data.keySkill,
                jobDescription: data.data.jobDescription,
                isSalarySpecified: !data?.data?.isSalarySpecified,
                currency: data?.data?.currency ?? '',
                maxSalary: data?.data?.maxSalary ?? null,
                minSalary: data?.data?.minSalary ?? null,
                salaryType: data?.data?.salaryType ?? ''
            })

            setckeditordata(data.data.jobDescription)

            // locationField.current.value = 'data.data.location'
            setuserSkills(
                data.data.keySkill.split(',').map((e) => {
                    return { name: e }
                })
            )
            setValue(
                'keywords',
                data.data.keySkill.split(',').map((e) => {
                    return { name: e }
                })
            )
        }
    })

    //list category API

    async function categoryList() {
        return await requestApi.post(
            `category/list`,
            { limit: 550 },
            { headers: true }
        )
    }
    const { data: categoryDataList } = useQuery({
        queryKey: ['category'],
        queryFn: () => categoryList('country')
        // enabled: !!userProfile
    })

    const deleteSkill = (id) => {
        setuserSkills((prev) => prev.filter((skill) => skill?._id !== id))
        if (userSkills.length === 1) {
            setError('keywords', 'Please Select Keywords')
        }
    }
    const { data: jobSkills } = useQuery({
        queryKey: ['jobSkill', skill],
        queryFn: () => fetchQuery(skill),
        enabled: !!skill,
        onSuccess: (data) => {}
    })

    let timmer
    const handleChangeSkill = (e) => {
        if (timmer) {
            clearTimeout(timmer)
        }
        timmer = setTimeout(() => {
            setSkill(e.target.value)
        }, 400)
    }

    //////// add-edit api for new opening job //////
    // const statelocation = useLocation()
    async function newAddJobOpening({ industry, location, ...payload }) {
        if (jobOpeningId) {
            let industryName = industry
            return await requestApi
                .post(
                    `job-opening/add-edit`,
                    {
                        ...payload,
                        location,
                        // industry: industryName?.industryId,
                        // experience: payload.experience.split(' ')[0],
                        jobOpeningId
                    },
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        } else {
            // let locationName = JSON.parse(location)
            let industryName = industry
            return await requestApi
                .post(
                    `job-opening/add-edit`,
                    {
                        ...payload,
                        location,
                        // experience: payload.experience.split(' ')[0],
                        // industry: industryName?.industryId
                    },
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        }
    }
    const mutation = useMutation(newAddJobOpening, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                navigate(jobopeningmanagement)
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    //Start Drop down for location////
    const IconOptionLocation = (props) => {
        const { label, location } = props.data

        return (
            <Option {...props}>
                <div className="react-select-option">{location}</div>
            </Option>
        )
    }

    const [userLocation, setUserlocation] = useState([])
    const [searchDeatails, setSearchDeatails] = useState({
        location: ''
    })

    let locationTimmer
    const handleChangeLocation = (e) => {
        if (locationTimmer) {
            clearTimeout(locationTimmer)
        }
        locationTimmer = setTimeout(() => {
            setChangeDataLoaction(e)
            // setChangeDataLoaction(e.target.value)
        }, 400)
    }
    function handleDropDown(fieldValue, fieldName) {
        setUserlocation((prev) => {
            return { ...prev, [fieldName]: JSON.parse(fieldValue) }
        })
    }
    const addLocationData = (selectedSkill, fieldValue, fieldName) => {
        setUserlocation((prev) => {
            return { ...prev, [fieldName]: fieldValue }
        })
        locationField.current.value = ''
    }
    // end Drop Down for location///

    // industry search dropDown /////
    const [userIndustry, setUserIndustry] = useState([])
    const [changeDataIndustry, setChangeDataIndustry] = useState('')

    let industryTimmer
    const handleChangeIndustry = (e) => {
        if (industryTimmer) {
            clearTimeout(industryTimmer)
        }
        industryTimmer = setTimeout(() => {
            setChangeDataIndustry(e.target.value)
        }, 400)
    }

    const addIndustryData = (selectedSkill, fieldValue, fieldName) => {
        setUserIndustry((prev) => {
            return { ...prev, [fieldName]: fieldValue }
        })
        industryField.current.value = ''
    }

    // end industry drop-down /////

    ///////// view api for data ////
    async function viewJobOpeningData(jobOpening) {
        return await requestApi
            .post(
                `/job-opening/view`,
                { jobOpeningId: jobOpening },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data, isLoading } = useQuery({
        queryKey: ['view-job-profile'],
        queryFn: () => viewJobOpeningData(jobOpeningId),
        enabled: !!jobOpeningId,
        onSuccess: (data) => {
            // const blocksFromHTML = htmlToDraft(data.data.jobDescription)
            // setEditorState(
            //     EditorState.createWithContent(
            //         customContentStateConverter(
            //             ContentState.createFromBlockArray(
            //                 blocksFromHTML.contentBlocks,
            //                 blocksFromHTML.entityMap
            //             )
            //         )
            //     )
            // )
            reset({
                jobTitle: data.data.jobTitle,
                shiftType: data.data.shiftType,
                categoryId: {
                    categoryId: data?.data?.categoryId,
                    categoryName: data?.data?.categoryName
                },
                // categoryId: data.data.categoryId.categoryName,
                jobRole: data.data.jobRole,
                experience: data.data.experience,
                jobType: data.data.jobType,
                jobGrade: data.data.jobGrade,
                salary: data.data.salary,
                salaryType: data.data.salaryType,
                summary: data.data.summary,
                mainDuty: data.data.mainDuty,
                aboutUs: data.data.aboutUs,
                description: data.data.description,
                lookingFor: data.data.lookingFor,
                additionalInfo: data.data.additionalInfo,
                // industry: data.data.industry,
                // industry: {
                //     industryName: data?.data?.industryName,
                //     industryId: data?.data?.industry
                // },
                // location: {
                //     cityId: data?.data?.locationId,
                //     location: data?.data?.location
                // },
                location: data?.data?.location,
                // experience:
                //     data.data.experience > 1
                //         ? `${data.data.experience} Years`
                //         : `${data.data.experience} Year`,
                // jobType: data.data.jobType,
                // salary: data.data.salary,
                // totalOpening: data.data.totalOpening,
                // jobStatus: data.data.jobStatus,
                // locationType: data.data.locationType,
                // keySkill: data.data.keySkill,
                // jobDescription: data.data.jobDescription,
                // isSalarySpecified: !data?.data?.isSalarySpecified,
                // currency: data?.data?.currency ?? 'INR',
                // maxSalary: data?.data?.maxSalary,
                // minSalary: data?.data?.minSalary,
                // salaryType: data?.data?.salaryType ?? 'Per Anum'
            })

            setckeditordata(data.data.jobDescription)
            // locationField.current.value = data.data.location
            // setuserSkills(
            //     data.data.keySkill.split(',').map((e) => {
            //         return { name: e }
            //     })
            // )
            // setValue(
            //     'keywords',
            //     data.data.keySkill.split(',').map((e) => {
            //         return { name: e }
            //     })
            // )
        },
        onError: (error) => {
            if(error.message !== null){
                navigate(jobopeningmanagement)
            }
        }
    })
    //////////// end view /////

    // ////
    const addSkill = (selectedSkill) => {
        setuserSkills((prev) => {
            if (
                prev.some((p) => {
                    return p._id === selectedSkill?._id
                })
            ) {
                setValue('keywords', prev)
                return prev
            } else {
                setValue('keywords', [...prev, selectedSkill])
                return [...prev, selectedSkill]
            }
        })

        skillField.current.value = ''
    }
    const customContentStateConverter = (contentState) => {
        // changes block type of images to 'atomic'
        const newBlockMap = contentState.getBlockMap().map((block) => {
            const entityKey = block.getEntityAt(0)
            if (entityKey !== null) {
                const entityBlock = contentState.getEntity(entityKey)
                const entityType = entityBlock.getType()
                switch (entityType) {
                    case 'IMAGE': {
                        const newBlock = block.merge({
                            type: 'atomic',
                            text: 'img'
                        })
                        return newBlock
                    }
                    default:
                        return block
                }
            }
            return block
        })
        const newContentState = contentState.set('blockMap', newBlockMap)
        return newContentState
    }

    function handleCKEditor(event, editor) {
        const data = editor.getData()

        setckeditordata(data)
    }

    const onSubmit = (data) => {
        const payload = {
            jobTitle: data.jobTitle,
            shiftType: data.shiftType,
            categoryId: data.categoryId.categoryId,
            location: data.location,
            jobRole: data.jobRole,
            jobType: data.jobType,
            experience: data.experience,
            jobGrade: data.jobGrade,
            salary: data.salary,
            salaryType: data.salaryType,
            summary: data.summary,
            mainDuty: data.mainDuty,
            aboutUs: data.aboutUs,
            description: data.description,
            lookingFor: data.lookingFor,
            additionalInfo: data.additionalInfo
        }
        mutation.mutate(payload)
    }
    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            // const color = chroma(data.color);
            return {
                ...styles,
                backgroundColor: isFocused ? '#002a3a' : null,
                color: isFocused ? 'white' : 'black',
                ':active': {
                    backgroundColor: '#002a3a'
                }
            }
        }
    }
    return (
        <div className="sidebar-content">
            {viewOnCopy || isFetching ? (
                <div className="spinner-wrapper">
                    <Spinner animation="border" role="status" className="tdata">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <div className="whitebox">
                            {jobOpeningId ? (
                                <div className="title-text">
                                         <span className='back-btn' onClick={()=>navigate(-1)}>
                                     <LeftArrowIcon />
                                     Back
                                     </span>
                                    <h3>Edit Job Opening</h3>
                                </div>
                            ) : (
                                <div className="title-text">
                                     <span className='back-btn' onClick={()=>navigate(-1)}>
                                     <LeftArrowIcon />
                                     Back
                                     </span>
                                    <h3>Create New Opening</h3>
                                </div>
                            )}

                            <div className="createnew-box">
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <InputControl
                                                autoFocus="true"
                                                label="Job Title"
                                                name="jobTitle"
                                                register={register}
                                                error={
                                                    errors?.jobTitle?.message
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <DropDownControlForCategery
                                                id={true}
                                                name="categoryId"
                                                label="Category"
                                                control={control}
                                                options={
                                                    categoryDataList?.data?.data
                                                }
                                                openOnFocus={true}
                                                // className="icontrol"
                                                register={register}
                                                error={errors.categoryId?.message}
                                                // getCountry={(countryId) => {
                                                //     // setCountryId()
                                                //     // setValue('city', JSON.stringify({ _id: '', name: '' }))
                                                // }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <Form.Label className="lcontrol">
                                                Shift Type
                                            </Form.Label>
                                            <DropDownControl
                                                name="shiftType"
                                                control={control}
                                                options={[
                                                    'Day shift',
                                                    'Night shift'
                                                ]}
                                                register={register}
                                                error={
                                                    errors.shiftType?.message
                                                }
                                            />
                                        </div>
                                    </div>

                              

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        {/* location start */}
                                        <div className="mb-3 input-wrapper location-input">
                                            <Form.Label className="lcontrol">
                                                Location
                                            </Form.Label>

                                            <Controller
                                                control={control && control}
                                                name='location'
                                                render={({
                                                    field: { value, onChange }
                                                }) => (
                                                <>
                                                
                                            <GooglePlacesAutocomplete
                                            apiKey={process.env.REACT_APP_PLACE_API_KEY}
                                            selectProps={{
                                                value: value,
                                                onChange: onChange,
                                                onSelect:handlePlaceSelect, // Call handlePlaceSelect when a place is selected
                                            }}

                                            render={({ getInputProps, suggestions, getSuggestionItemProps }) => (
                                                <div>
                                                <input {...getInputProps()} />
                                                <ul>
                                                    {suggestions?.map((suggestion) => (
                                                    <li {...getSuggestionItemProps(suggestion)}>
                                                        {suggestion?.description}
                                                        
                                                    </li>
                                                    ))}
                                                </ul>
                                                </div>
                                            )}                
                                            />
                                            </>  )} />
      
                                            {errors?.location?.message && (
                                                <span
                                                    className="error-message"
                                                    style={{ color: 'red' }}
                                                >
                                                    {errors?.location?.message}
                                                </span>
                                            )}
                                        </div>{' '}
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <InputControl
                                                label="Job Role"
                                                name="jobRole"
                                                register={register}
                                                error={errors?.jobRole?.message}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <InputControl
                                                label="Experience"
                                                name="experience"
                                                register={register}
                                                error={
                                                    errors?.experience?.message
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <Form.Label className="lcontrol">
                                                Job Type
                                            </Form.Label>
                                            <DropDownControl
                                                name="jobType"
                                                control={control}
                                                options={[
                                                    'Full time',
                                                    'Part time'
                                                ]}
                                                register={register}
                                                error={errors.jobType?.message}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <InputControl
                                                label="Job Grade"
                                                name="jobGrade"
                                                register={register}
                                                error={
                                                    errors?.jobGrade?.message
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <InputControl
                                                // type="number"
                                                label="Salary (£)"
                                                name="salary"
                                                register={register}
                                                error={errors?.salary?.message}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                        <div className="mb-3 input-wrapper">
                                            <Form.Label className="lcontrol">
                                                Salary Type
                                            </Form.Label>
                                            <DropDownControl
                                                name="salaryType"
                                                control={control}
                                                options={['Hourly','Monthly','Annualy']}
                                                register={register}
                                                error={
                                                    errors.salaryType?.message
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Description</h3>
                            </div>
                            <div className="jobdesbox">
                                <div className="createnew-box heightbox">
                                    <Controller
                                        control={control && control}
                                        name={'description'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    //     allowedContent: true,
                                                    //     extraAllowedContent: true,
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data =
                                                        editor.getData()
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />

                                    <span className="error-message">
                                        {errors.description?.message}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Summary</h3>
                            </div>
                            <div className="jobdesbox">
                                <div className="createnew-box heightbox">
                                    <Controller
                                        control={control && control}
                                        name={'summary'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    link: {
                                                        addTargetToExternalLinks: true
                                                    }
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data =
                                                        editor.getData()
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />

                                    <span className="error-message">
                                        {errors.summary?.message}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Main Duty</h3>
                            </div>
                            <div className="jobdesbox">
                                <div className="createnew-box heightbox">
                                    <Controller
                                        control={control && control}
                                        name={'mainDuty'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    link: {
                                                        addTargetToExternalLinks: true
                                                    }
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data =
                                                        editor.getData()
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />

                                    <span className="error-message">
                                        {errors.mainDuty?.message}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>About Us</h3>
                            </div>
                            <div className="jobdesbox">
                                <div className="createnew-box heightbox">
                                    <Controller
                                        control={control && control}
                                        name={'aboutUs'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    link: {
                                                        addTargetToExternalLinks: true
                                                    }
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data =
                                                        editor.getData()
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />

                                    <span className="error-message">
                                        {errors.aboutUs?.message}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Looking For</h3>
                            </div>
                            <div className="jobdesbox">
                                <div className="createnew-box heightbox">
                                    <Controller
                                        control={control && control}
                                        name={'lookingFor'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    link: {
                                                        addTargetToExternalLinks: true
                                                    }
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data =
                                                        editor.getData()
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />

                                    <span className="error-message">
                                        {errors.lookingFor?.message}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox">
                            <div className="title-text">
                                <h3>Additional Info</h3>
                            </div>
                            <div className="jobdesbox">
                                <div className="createnew-box heightbox">
                                    <Controller
                                        control={control && control}
                                        name={'additionalInfo'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    link: {
                                                        addTargetToExternalLinks: true
                                                    }
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data =
                                                        editor.getData()
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />

                                    <span className="error-message">
                                        {errors.additionalInfo?.message}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="whitebox" style={{ padding: '20px' }}>
                            <div
                                className="jobdes-btn"
                                style={{ marginTop: '0px' }}
                            >
                                <ButtonWithLoader
                                    isLoading={mutation?.isLoading}
                                    cssClass="common-btn comman-auth-btn reset-btn"
                                >
                                    {jobOpeningId ? (
                                        <button
                                            type="submit"
                                            className="common-btn create"
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="common-btn create"
                                        >
                                            Create
                                        </button>
                                    )}
                                </ButtonWithLoader>
                                <button
                                    type="button"
                                    className="common-btn cancel"
                                    onClick={handleCancleButton}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Form>
                </>
            )}
            <Modal
                className="modalbox"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <div className="modal-title">
                        <h3>Add Skill</h3>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        className="row"
                        onSubmit={skillhandleSubmit(handleOnSubmit)}
                    >
                        <div className="col-12">
                            <InputControl
                                //    disabled={!!CVEId}
                                label="Skill Name"
                                name="skill"
                                register={skillregister}
                                error={skillerrors.skill?.message}
                                autoComplete="off"
                            />
                        </div>

                        <div className=" col-12">
                            <div className="save">
                                <ButtonWithLoader
                                    isLoading={addnewmutation?.isLoading}
                                    cssClass="common-btn"
                                >
                                    <button
                                        className="common-btn"
                                        type="submit"
                                    >
                                        Save
                                    </button>
                                </ButtonWithLoader>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default CreatNewOpening
